import React from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { baseOptionTypeArrayToStringArray } from 'components/BaseForm/utils';
import { TableSort } from 'components/WrappedComponents/Table/types';
import { useExportDashboard } from 'hooks/dossiers/useExportDashboard';
import { useUserStore } from 'hooks/UserStoreContext';

import { FilterDashboardAutoriteFourriere } from '../Filters/types';

interface DownloadButtonProps<SortType extends string | undefined> {
  filters: Partial<FilterDashboardAutoriteFourriere>;
  sort: TableSort<SortType>;
}

function DownloadButton<SortType extends string | undefined>({
  filters,
  sort,
}: DownloadButtonProps<SortType>): React.ReactElement {
  const { exportDashboard, inProgress } = useExportDashboard();
  const user = useUserStore();

  return (
    <AntdButton
      icon={<DownloadOutlined />}
      type={'default'}
      shape={'round'}
      onClick={() => {
        exportDashboard(sort, {
          includeDossiersSortis: filters.includeDossiersSortis,
          communeEnlevementList: baseOptionTypeArrayToStringArray(
            filters.commune,
          ),
          classementList: filters.classement,
          dateRangeMiseEnFourriere: filters.dateRangeMiseEnFourriere,
          dateRangeBonEnlevement: filters.dateRangeBonEnlevement,
          idNatureBrancheList: filters.natureMiseEnFourriere,
          numeroRecherche: filters.search,
          idFourriereList: baseOptionTypeArrayToStringArray(filters.fourriere),
          idAutoriteFourriere: user.idCorrelationAutoriteFourriere || undefined,
          statutDossierEnumList: filters.statut,
          dateRangeSortieDefinitive: filters.dateRangeSortieDefinitive,
          actionsRequises: filters.actionsRequises,
          idMotifSortieList: filters.motifDeSortie,
          statutsFacturation: filters.statutsTraitementFacturation,
          includeDossiersAnonymises: filters.includeDossiersAnonymises,
          dateRangeOrdreDestruction: filters.dateRangeOrdreDestruction,
        });
      }}
      loading={inProgress}
    />
  );
}

export default DownloadButton;
